import React, { Component } from 'react'
import moment from 'moment'

// ─── helpers ─────────────────────────────────────────────────────────────────
function toNum(v) { const n = parseFloat(v); return isNaN(n) ? 0 : n }

function fmtRupiah(n) {
  const v = Math.round(toNum(n))
  if (v === 0) return '-'
  return new Intl.NumberFormat('id-ID').format(v)
}

function fmtAccum(n) {
  // Accum dep tampil dengan kurung (negatif secara visual) sesuai screenshot
  const v = Math.round(toNum(n))
  if (v === 0) return '-'
  return '(' + new Intl.NumberFormat('id-ID').format(Math.abs(v)) + ')'
}

// kode_plant > 4 karakter = HO
const isHO   = (p) => p && p.length > 4
const isArea = (p) => p && p.length <= 4

// SAP ADA  = status_doc !== 1
// SAP TIDAK ADA = status_doc === 1
// FISIK ADA = status_fisik === 'ada'  (atau Belum submit dianggap fisik ada)
// FISIK TIDAK ADA = status_fisik === 'tidak ada'
const sapAda       = (x) => x.status_doc !== 1
const sapTidakAda  = (x) => x.status_doc === 1
const fisikAda     = (x) => x.status_fisik === 'ada' || x.new_status === 'Belum submit'
const fisikTidakAda= (x) => x.status_fisik === 'tidak ada'

// clear_flag: 'clear' atau NULL = clear; 'unclear' = tidak clear
const isClear   = (x) => !x.clear_flag || x.clear_flag === 'clear'
const isUnclear = (x) => x.clear_flag === 'unclear'

// ─── styles ──────────────────────────────────────────────────────────────────
const S = {
  wrap:       { fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#222', maxWidth: 900 },
  title:      { textAlign: 'center', fontWeight: 700, fontSize: 13, marginBottom: 16, letterSpacing: 0.3 },
  tbl:        { width: '100%', borderCollapse: 'collapse', marginBottom: 18 },
  thL:        { padding: '6px 10px', fontWeight: 700, fontSize: 12, borderBottom: '1.5px solid #333', borderTop: '1.5px solid #333', textAlign: 'left', background: '#fff' },
  thR:        { padding: '6px 10px', fontWeight: 700, fontSize: 12, borderBottom: '1.5px solid #333', borderTop: '1.5px solid #333', textAlign: 'right', background: '#fff', whiteSpace: 'nowrap' },
  td:         { padding: '5px 10px', borderBottom: '0.5px solid #e8e8e8', textAlign: 'left' },
  tdR:        { padding: '5px 10px', borderBottom: '0.5px solid #e8e8e8', textAlign: 'right', whiteSpace: 'nowrap' },
  tdBold:     { padding: '5px 10px', borderBottom: '0.5px solid #ccc', fontWeight: 700, textAlign: 'left' },
  tdBoldR:    { padding: '5px 10px', borderBottom: '0.5px solid #ccc', fontWeight: 700, textAlign: 'right', whiteSpace: 'nowrap' },
  rowTotal:   { background: '#f0f0f0' },
  rowSubtotal:{ background: '#fafafa' },
  rowBalance: { background: '#fff' },
  rowPink:    { background: '#fce8e8' },  // Balance checked / Area Tidak Clear
  rowGreen:   { background: '#e8f5f0' },  // Area Clear
  rowDark:    { background: '#f4f4f2' },
  sectionGap: { height: 14 },
  noteBox:    { border: '1px solid #333', padding: '10px 14px', fontSize: 11, lineHeight: 1.6, marginTop: 8 },
  noteBold:   { fontWeight: 700 },
  separator:  { borderTop: '1.5px solid #333', margin: '4px 0' },
}

// ─── Component ───────────────────────────────────────────────────────────────
class SummaryOpname extends Component {

  compute(data) {
    if (!data || data.length === 0) return null

    // ── 1. Rekap Nilai ────────────────────────────────────────────────────────
    // SAP = FISIK AREA : SAP ada, fisik ada, plant Area, sudah kirim
    const sapFisikArea   = data.filter(x => sapAda(x) && fisikAda(x) && isArea(x.kode_plant) && x.new_status !== 'Belum submit')
    // SAP = FISIK HO   : SAP ada, fisik ada, plant HO, sudah kirim
    const sapFisikHO     = data.filter(x => sapAda(x) && fisikAda(x) && isHO(x.kode_plant) && x.new_status !== 'Belum submit')
    // SAP ADA FISIK TIDAK : SAP ada, fisik tidak ada, sudah kirim
    const sapAdaFisikTdk = data.filter(x => sapAda(x) && fisikTidakAda(x) && x.new_status !== 'Belum submit')
    // ASSET MUTASI : grouping mengandung 'MUTASI', sudah kirim
    const assetMutasi    = data.filter(x => x.grouping && x.grouping.toUpperCase().includes('MUTASI') && x.new_status !== 'Belum submit')

    // Total Rekon = semua sudah kirim, sesimple ini
    const sudahKirim = data.filter(x => x.new_status !== 'Belum submit')

    const sum = (arr) => ({
      acquis: arr.reduce((s, x) => s + toNum(x.nilai_acquis), 0),
      accum:  arr.reduce((s, x) => s + toNum(x.accum_dep),   0),
      buku:   arr.reduce((s, x) => s + toNum(x.nilai_buku),  0),
      unit:   arr.length,
    })

    const r = {
      sapFisikArea:    sum(sapFisikArea),
      sapFisikHO:      sum(sapFisikHO),
      sapAdaFisikTdk:  sum(sapAdaFisikTdk),
      kendaraan:       { acquis: 0, accum: 0, buku: 0, unit: 0 },
      assetMutasi:     sum(assetMutasi),
    }

    // Total rekonsiliasi = semua yang sudah kirim (new_status !== 'Belum submit')
    r.totalRekon = sum(sudahKirim)

    // Total Area yang tidak kirim = plant Area, belum submit
    const areaTidakKirimArr = data.filter(x => x.new_status === 'Belum submit')
    r.areaTidakKirim = sum(areaTidakKirimArr)
    // jumlah plant unik Area dan HO yang tidak kirim
    r.areaTidakKirimAreaCount = new Set(areaTidakKirimArr.filter(x => isArea(x.kode_plant)).map(x => x.kode_plant).filter(Boolean)).size
    r.areaTidakKirimHOCount   = new Set(areaTidakKirimArr.filter(x => isHO(x.kode_plant)).map(x => x.kode_plant).filter(Boolean)).size

    // Asset Balance SAP = Total Rekon + Total Area tidak kirim
    r.totalSAP = {
      acquis: r.totalRekon.acquis + r.areaTidakKirim.acquis,
      accum:  r.totalRekon.accum  + r.areaTidakKirim.accum,
      buku:   r.totalRekon.buku   + r.areaTidakKirim.buku,
      unit:   r.totalRekon.unit   + r.areaTidakKirim.unit,
    }

    // Balance Checked = selisih (idealnya 0, tampilkan '-')
    r.balance = {
      acquis: r.totalSAP.acquis - r.totalRekon.acquis - r.areaTidakKirim.acquis,
      accum:  r.totalSAP.accum  - r.totalRekon.accum  - r.areaTidakKirim.accum,
      buku:   r.totalSAP.buku   - r.totalRekon.buku   - r.areaTidakKirim.buku,
    }

    // ── 2. Count Items ────────────────────────────────────────────────────────
    r.idle   = data.filter(x => x.grouping && (
      x.grouping.toUpperCase().includes('TIDAK TERPAKAI') ||
      x.grouping.toUpperCase().includes('IDLE')
    )).length

    r.rusak  = data.filter(x => x.kondisi && x.kondisi.toLowerCase() === 'rusak').length

    r.fisikAdaSapTdkBelumGR     = data.filter(x => fisikAda(x) && sapTidakAda(x) && x.grouping && x.grouping.toUpperCase().includes('BELUM DI GR')).length
    r.fisikAdaSapTdkBelumTerdaftar = data.filter(x => fisikAda(x) && sapTidakAda(x) && x.grouping && x.grouping.toUpperCase().includes('BELUM TERDAFTAR')).length
    r.fisikAdaSapTdkTidakAda    = data.filter(x => fisikAda(x) && sapTidakAda(x) && x.grouping && x.grouping.toUpperCase().includes('TIDAK ADA NOMOR')).length

    r.hilang = data.filter(x => x.grouping && x.grouping.toUpperCase().includes('HILANG')).length
    // breakdown hilang per Area vs HO
    r.hilangArea = data.filter(x => x.grouping && x.grouping.toUpperCase().includes('HILANG') && isArea(x.kode_plant)).length
    r.hilangHO   = data.filter(x => x.grouping && x.grouping.toUpperCase().includes('HILANG') && isHO(x.kode_plant)).length

    // ── 3. Area Clear / Tidak Clear ───────────────────────────────────────────
    // Ambil plant unik Area saja
    const areaPlants = [...new Set(data.filter(x => x.kode_plant !== null).map(x => x.kode_plant).filter(Boolean))]
    const totalArea  = areaPlants.length

    // Satu aset unclear di plant → plant itu unclear
    const unclearPlants = areaPlants.filter(p => data.some(x => x.kode_plant === p && isUnclear(x)))
    const clearPlants   = areaPlants.filter(p => !unclearPlants.includes(p))

    r.areaClear      = clearPlants.length
    r.areaTidakClear = unclearPlants.length
    r.totalAreaNasional = totalArea
    r.pctClear       = totalArea > 0 ? Math.round(clearPlants.length / totalArea * 100) : 0
    r.pctTidakClear  = totalArea > 0 ? Math.round(unclearPlants.length / totalArea * 100) : 0

    return r
  }

  render() {
    const { newReport = [], periodeLabel, title, time2 } = this.props
    const r = this.compute(newReport)

    const displayTitle = title || `OPNAME ASSET${periodeLabel ? ' ' + periodeLabel.toUpperCase() : ''}`

    const colW = { label: '47%', acquis: '16%', accum: '16%', buku: '11%', eksekusi: '10%' }

    const RekapRow = ({ label, vals, bold, bg, indent, eksekusi }) => (
      <tr style={bg ? { background: bg } : {}}>
        <td style={bold ? { ...S.tdBold, paddingLeft: indent ? 22 : 10 } : { ...S.td, paddingLeft: indent ? 22 : 10 }}>{label}</td>
        <td style={bold ? S.tdBoldR : S.tdR}>{vals ? fmtRupiah(vals.acquis) : ''}</td>
        <td style={bold ? S.tdBoldR : S.tdR}>{vals ? fmtAccum(vals.accum)   : ''}</td>
        <td style={bold ? S.tdBoldR : S.tdR}>{vals ? fmtRupiah(vals.buku)   : ''}</td>
        <td style={{ ...S.td, color: '#c0392b', fontStyle: 'italic', fontSize: 11 }}>
          {eksekusi || (vals && vals.unit > 0 ? `${vals.unit} unit` : '')}
        </td>
      </tr>
    )

    const CountRow = ({ label, count, note, bg, bold }) => (
      <tr style={bg ? { background: bg } : {}}>
        <td style={bold ? S.tdBold : S.td}>{label}</td>
        <td style={bold ? S.tdBoldR : S.tdR}>{count !== undefined && count !== null ? count : ''}</td>
        <td style={S.td}></td>
        <td style={S.td}></td>
        <td style={{ ...S.td, color: '#c0392b', fontStyle: 'italic', fontSize: 11 }}>{note || ''}</td>
      </tr>
    )

    if (!r) {
      return (
        <div style={{ ...S.wrap, padding: 24, color: '#aaa', textAlign: 'center' }}>
          Belum ada data untuk ditampilkan.
        </div>
      )
    }

    return (
      <div style={S.wrap}>
        <div style={S.title}>{displayTitle}</div>

        {/* ══ SECTION 1: REKAPITULASI NILAI ══════════════════════════════════ */}
        <table style={S.tbl}>
          <colgroup>
            <col style={{ width: colW.label }} />
            <col style={{ width: colW.acquis }} />
            <col style={{ width: colW.accum }} />
            <col style={{ width: colW.buku }} />
            <col style={{ width: colW.eksekusi }} />
          </colgroup>
          <thead>
            <tr>
              <th style={S.thL}>REKAPITULASI</th>
              <th style={S.thR}>Acquis.val.</th>
              <th style={S.thR}>Accum.dep.</th>
              <th style={S.thR}>Book val.</th>
              <th style={S.thR}>EKSEKUSI</th>
            </tr>
          </thead>
          <tbody>
            <RekapRow label="SAP = FISIK AREA"     vals={r.sapFisikArea} />
            <RekapRow label="SAP = FISIK HO"       vals={r.sapFisikHO} />
            <RekapRow label="SAP ADA FISIK TIDAK"  vals={r.sapAdaFisikTdk} bg="#fff0f0" />
            <RekapRow label="SAP ADA FISIK TIDAK - KENDARAAN" vals={r.kendaraan} bg="#fff0f0" indent />
            <RekapRow label="ASSET MUTASI"         vals={r.assetMutasi} />
            <RekapRow
              label="Total Rekonsiliasi Hasil Opname AREA NASIONAL & HO TGR NON IT"
              vals={r.totalRekon}
              bold
              bg="#f0f0f0"
            />
            <RekapRow
              label="Total Area yang tidak kirim"
              vals={r.areaTidakKirim}
              bold
              bg="#f0f0f0"
              eksekusi={`${r.areaTidakKirim.unit} unit; ${r.areaTidakKirimAreaCount} area; ${r.areaTidakKirimHOCount} ho`}
            />
            <RekapRow
              label={`Asset Balance SAP per 26 ${moment(time2).format('MMMM YYYY')}`}
              vals={r.totalSAP}
              bg="#fafafa"
            />
            <tr style={{ background: '#fce8e8' }}>
              <td style={{ ...S.tdBold, fontStyle: 'italic' }}>Balance Checked</td>
              <td style={{ ...S.tdBoldR, fontStyle: 'italic' }}>-</td>
              <td style={{ ...S.tdBoldR, fontStyle: 'italic' }}>-</td>
              <td style={{ ...S.tdBoldR, fontStyle: 'italic' }}>-</td>
              <td style={S.td}></td>
            </tr>
          </tbody>
        </table>

        {/* ══ SECTION 2: COUNT ITEMS ══════════════════════════════════════════ */}
        <table style={S.tbl}>
          <colgroup>
            <col style={{ width: colW.label }} />
            <col style={{ width: '10%' }} />
            <col />
            <col />
            <col style={{ width: '20%' }} />
          </colgroup>
          <tbody>
            <CountRow label="IDLE"  count={r.idle  || ''} />
            <CountRow label="RUSAK" count={r.rusak || ''} />
            <CountRow label="FISIK ADA SAP TIDAK ADA - Asset Belum di GR"        count={r.fisikAdaSapTdkBelumGR        || ''} />
            <CountRow label="FISIK ADA SAP TIDAK ADA - Asset Belum Terdaftar"    count={r.fisikAdaSapTdkBelumTerdaftar || ''} />
            <CountRow label="FISIK ADA SAP TIDAK ADA - Tidak ada nomor Asset"    count={r.fisikAdaSapTdkTidakAda       || ''} />
            <CountRow
              label="HILANG"
              count={r.hilang || ''}
              note={
                r.hilang > 0
                  ? `unit area ${r.hilangArea}; unit ho ${r.hilangHO}`
                  : ''
              }
            />
          </tbody>
        </table>

        {/* ══ SECTION 3: AREA CLEAR / TIDAK CLEAR ════════════════════════════ */}
        <table style={S.tbl}>
          <colgroup>
            <col style={{ width: colW.label }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '8%' }} />
            <col />
          </colgroup>
          <tbody>
            <tr style={S.rowGreen}>
              <td style={{ ...S.tdBold, fontStyle: 'italic', color: '#1a7a55' }}>Area Clear</td>
              <td style={{ ...S.tdBoldR, fontStyle: 'italic', color: '#1a7a55' }}>{r.areaClear}</td>
              <td style={{ ...S.tdBoldR, fontStyle: 'italic', color: '#1a7a55' }}>{r.pctClear}%</td>
              <td style={S.td}></td>
            </tr>
            <tr style={S.rowPink}>
              <td style={{ ...S.tdBold, fontStyle: 'italic', color: '#c0392b' }}>Area Tidak Clear</td>
              <td style={{ ...S.tdBoldR, fontStyle: 'italic', color: '#c0392b' }}>{r.areaTidakClear}</td>
              <td style={{ ...S.tdBoldR, fontStyle: 'italic', color: '#c0392b' }}>{r.pctTidakClear}%</td>
              <td style={S.td}></td>
            </tr>
            <tr>
              <td style={S.tdBold}>Total Area Nasional</td>
              <td style={S.tdBoldR}>{r.totalAreaNasional}</td>
              <td style={S.tdBoldR}>100%</td>
              <td style={S.td}></td>
            </tr>
          </tbody>
        </table>

        {/* ══ NOTE ════════════════════════════════════════════════════════════ */}
        <div style={S.noteBox}>
          <span style={S.noteBold}>Note:</span><br />
          Hasil rekon Opname ini sudah diinformasikan dan dikonfirmasi ulang kepada semua area ybs, dan penyelesaian
          permasalahan asset (baik Mutasi, Asset belum di GR, Asset tidak ada di fisik, dll) sedang dalam proses penyelesaian,
          serta berkesinambungan dengan penyelesaian Audit dari KKP Tim BC.
        </div>
      </div>
    )
  }
}

export default SummaryOpname